import React from 'react';
import { PageSection, ListFieldSection } from '../Layout';
import { Field, Message, Checkbox } from '../Core';
import { useSelector } from 'react-redux';

const NotificationsAdmin = () => {
  const isPushNotificationsEnabled = useSelector((state) => state.admin.syncModel.EnablePushNotifications);
  const isQestnetConfigurationKeyInstalled = useSelector(
    (state) => state.environment.data.IsQestNetConfigurationKeyInstalled
  );

  return (
    <PageSection>
      <ListFieldSection single heading="Push Notifications">
        <Field
          label="Enable Push Notifications"
          input={<Checkbox />}
          disabled={!isQestnetConfigurationKeyInstalled && !isPushNotificationsEnabled}
          name="syncModel.EnablePushNotifications"
        />
        {!isQestnetConfigurationKeyInstalled && isPushNotificationsEnabled && (
          <Message severity="error">
            The QESTNet configuration key is not installed. This must be installed to send push notifications.
          </Message>
        )}
        {!isQestnetConfigurationKeyInstalled && !isPushNotificationsEnabled && (
          <Message severity="info">
            The QESTNet configuration key must be installed to enable push notifications.
          </Message>
        )}
      </ListFieldSection>
    </PageSection>
  );
};

export default NotificationsAdmin;
export { NotificationsAdmin };
